<template>
  <div>
    <a class="card vehicle-card" :href="vehicleURL">
      <div class="card-body" v-if="vehicle">
        <div class="mt-2">
          <div class="row head-row">
            <div class="col-12"><div v-html="vehicle.campaign"></div></div>
          </div>
          <div class="row col-12 head-row">
            <div
                class='delivery font-weight-bold mb-2'
                :class='{ "instant-available" : isInstantAvailable, "not-instant-available": !isInstantAvailable }'
            >
              <i class="fas fa-truck mr-1"></i>
              {{ generatedDeliveryText }}
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row d-flex justify-content-center">
            <img class="vehicle-image" :src="vehicle.title_image" :alt="vehicle.model.title" height='131px'>
          </div>
        </div>
        <div class="col-12">
          <div class="row text-center">
            <div class="col-12 text-ellipsis font-weight-bold vehicle-title pt-3">
              {{ vehicle.model.brand.title }} {{ vehicle.model.title }}
            </div>
            <div class="col-12 description text-ellipsis">
              {{ vehicle.description}}
            </div>
          </div>
        </div>
        <div class="col-12 mt-3">
          <div class="row d-flex justify-content-center">
            <div v-if='vehicle.has_campaign_prices && isActiveCampaign' class='price font-weight-bold'>
              <span class='old-price'>
                {{ oldPrice }} €
              </span>
              <span>ab</span> <span class='price' style='font-size: 20px; color: #ff0000'>{{ price }} €</span> <span>mtl.</span>
            </div>
            <div v-else :class='["price", "font-weight-bold", "price-"+vehicle.country]'>
              <span class="price font-weight-bold" style='font-size: 10px !important'>ab</span>
              {{ price }} €
              <span class='price font-weight-bold' style='font-size: 10px !important'>mtl.</span>
            </div>
          </div>
          <div class="row green--text font-weight-bold d-flex justify-content-center all-inclusive">
            <i class="fas fa-check-circle ml-2"></i>
            All-inclusive Preis
          </div>
          <div class="row d-flex justify-content-center">
            <button class="btn btn-primary btn-lg d-none d-md-block my-3">
              Details
              <i class="fas fa-chevron-right ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>

export default {
  name: "TopDealsSliderEntry",
  props: {
    vehicle: Object
  },
  data() {
    return {
      oldPrice: '',
      price: undefined,
      mileageText: undefined,
      cheapestOption: null,
			isActiveCampaign: false
    }
  },
  watch: {
  },
  computed: {
    vehicleURL() {
      const slug = this.createSlug(this.vehicle.title)
      return /katalog/ + slug + '-' + this.vehicle.id
    },
	  generatedDeliveryText(){
		  var periodPhrase = this.vehicle.available_text

		  if(this.isInstantAvailable || periodPhrase == 'Sofort verfügbar'){
			  return 'Verfügbarkeit: Sofort verfügbar'
		  }

		  return 'Verfügbarkeit: ab ' + periodPhrase
	  },
	  isInstantAvailable(){
		  let availability = this.vehicle.availability

		  return (availability.delivery_time_after_booking <= 10 && availability.type === 'INSTANT')
				  || (availability.delivery_period_days_until <= 10 && availability.delivery_period_days_until !== null)
	  }
  },
  methods: {
    createSlug: function(string){
      return string
          .normalize('NFD') // split an accented letter in the base letter and the acent
          .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
          .replace(/\s+/g, '-') // separator
    },
    getGearshift() {
      if(!this.vehicle.gearshift) {
        return '-';
      }
      if (this.vehicle.gearshift.id === 2) {
        return 'Manuell'
      }
      return this.vehicle.gearshift.title
    },

    getFuel() {
      if (this.vehicle.fuel.id === 10) return 'Elektro'
      else return this.vehicle.fuel.title
    },
    getYear(datestr) {
      if (!datestr) return ''
      return new Date(datestr).getFullYear()
    },
    async getLowestPriceAndMileage() {
      let priceField = 'price';
      if(this.vehicle.has_campaign_prices) {
        let isActive = false;

        try {
          const response = await fetch('/api/v1.0/vehicles/is-in-active-campaign/' + this.vehicle.id);
          const data = await response.json();
          isActive = data;
        } catch (error) {
        }

        if(isActive){
          priceField = 'campaign_price'
          this.isActiveCampaign = isActive
        }
      }

      let cheapestOption = this.vehicle['price_plans'];

      cheapestOption = cheapestOption.reduce((prev, curr) => prev[priceField] < curr[priceField] ? prev : curr)

      this.cheapestOption = cheapestOption;
      this.price = new Intl.NumberFormat('de').format(cheapestOption[priceField]);
      this.oldPrice =  new Intl.NumberFormat('de').format(cheapestOption['price']);

      this.mileageText = `bei ${cheapestOption.minimum_duration} ${cheapestOption.duration_id === 1 ? 'Monat' : 'Monaten'} und ${cheapestOption.mileage} km mtl.`
    },
  },
  created() {
    this.getLowestPriceAndMileage();
  }
};
</script>

<style scoped lang="scss">
.campaign-box {
  height: 48px;
}

.campaign-badge {
  background-color: #efefef;
  font-size: 11px;
  border-radius: 5px;
}

.instant-available {
  background-color: rgba(0, 152, 25, 0.28);
  color: #399600 !important;
  padding: 5px 16px;
  border-radius: 5px;
  i {
    color: #399600 !important;
  }
}

.not-instant-available {
  color: #000 !important;
  padding: 5px 16px;
  border-radius: 5px;
  border: solid 1px #efefef;
  background-color: #efefef;
  i {
    color: #000 !important;
  }
}

.head-row {
  padding-top: 10px;
}

.vehicle-image {
  max-width: 100%;
}

.detail-button {
  border-radius: 0.1rem;
}
.all-inclusive {
  .fas.fa-check-circle.ml-2 {
    padding-top: 2px;
    padding-right: 5px;
  }
}

.card {
  border: 0;
  .card-body {
    padding: 0rem;
  }
}

.details {
  .detail-icon {
    padding-top: 3px;
    padding-right: 5px;
  }

  .fa-clipboard-list {
    padding-left: 2px;
  }
}

.green--text {
  color: #399600 !important;
}

.old-price {
  position: absolute;
  top: -5px;
  font-weight: normal;
  font-size: 10px;
  color: #02020b;
  text-decoration: line-through;
}
.netto-price-text {
  position: absolute;
  top: -5px;
  font-weight: normal;
  font-size: 10px;
  color: #02020b;
}
.vehicle-card {
  cursor: pointer;
  min-height: 415px !important;
  color: #000;
  border: 1px solid rgba(185, 185, 185, 0.23);
  border-radius: 6px;
  box-shadow: rgba(185, 185, 185, 0.23) 0 0 6px 2px;
  .card-body {
    padding: 8px;
  }

  &:hover {
    text-decoration: none;
  }
  .delivery {
    font-size: 10px;
    min-height: 15px;
  }

  .vehicle-title {
    font-size: 17px;
  }

  .badge-row {
    min-height: 32px;
    line-height: 32px;
    padding: 0;
    .v-chip {
      padding: 0 8px;
      font-size: 11px;
      height: 22px;

      &:hover::before {
        opacity: 0 !important;
      }

      .fa-star {
        margin-bottom: 1px;
      }

      .fa-gem {
        margin-top: 0;
      }
    }
  }

  .description {
    font-size: 14px;
    min-height: 19px;
  }

  .details {
    font-size: 12px;
    margin-left: -2px;
    margin-right: -2px;

    .v-icon {
      margin-right: 6px;
      font-size: 12.7px !important;
    }
  }

  .business-price {
    color: #0064F6 !important;
  }
  .price {
    font-size: 20px;
    margin: 0.25rem 0;
    span {
      font-size: 10px;
    }
  }
  .price-ch {
    font-size: 13pt;

    span {
      font-size: 10px;
    }
  }
  .details-btn {
    height: 34px !important;
    padding: 0 13px !important;
    font-size: 13px !important;
  }
}

.vehicle-card.large-solo {
  .badge-row {
    margin-left: -3px;
    margin-right: -3px;

    .v-chip {
      font-size: 13px;
      height: 30px;
      padding: 0 11px;

      .fa-star {
        margin-bottom: 0px;
      }

      .fa-gem {
        margin-top: 0px;
      }
    }
  }

  .delivery {
    font-size: 13px;
  }

  .vehicle-title {
    font-size: 18px;
  }

  .description {
    font-size: 16px;
  }

  .details {
    font-size: 13px;

    .v-icon {
      font-size: 14px !important;
    }
  }

  .price {
    font-size: 21px;

    span {
      font-size: 11px;
    }
  }

}

.details-btn {
  height: 32px !important;
  padding: 0 16px !important;
  font-size: 14px !important;
  border-radius: 2px !important;
  background-color: #ff0000 !important;
}

.v-chip .v-chip__content{
  font-size: 11px;
}
</style>
